import React from 'react';
import classNames from 'classnames';

import { BreadcrumbsV2, DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { NodeEquipment } from '../../../../types/uncinc_profile/nodes';
import { ParagraphsRenderer } from '../../../../components';

import './style.scss';

interface EquipmentProps {
  entity: ImmutableEntity<NodeEquipment>;
  className?: string;
}

const NodeEquipmentPage: React.FC<EquipmentProps> = ({ entity, className }) => {
  const classes = classNames('Node', 'NodeEquipmentPage', className);

  const equipment = entity.toJS();
  const title = equipment.title[0].value;
  const body = equipment.body[0]?.processed;
  const media = equipment.field_media_item[0];
  const caption = media?.entity?.field_caption[0]?.value;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="NodeEquipmentPage__hero">
        <Container>
          <div className="row">
            <div className="col-12">
              <BreadcrumbsV2 showHomeIcon={false} />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-8 col-lg-10">
              <h1 className="NodeEquipmentPage__title" itemProp="title">
                {title}
              </h1>

              {body && (
                <WysiwygField
                  className="NodeEquipmentPage__body body--large"
                  property="schema:text"
                  html={body}
                />
              )}
            </div>
            {media && (
              <div className="col-12">
                <div className="NodeEquipmentPage__media-wrapper">
                  <DynamicMediaItem
                    className="NodeEquipmentPage__media"
                    media={media}
                    imageAspectRatio="2_1"
                  />
                  {/* We render the caption outside, to prevent layout shifting */}
                  {caption && (
                    <p className="caption">{caption}</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </Container>
      </div>

      <ParagraphsRenderer className="NodeEquipmentPage__paragraphs" paragraphs={entity.get('field_paragraphs')} isWide />
    </article>
  );
};

export default NodeEquipmentPage;
